import React from 'react';

//sitewise layer icon
const RotationRoadIcon = () => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 21 14"
        fill="currentColor"
    >
        <path d="M20.8976 12.3473L15.8011 0.680672C15.6199 0.265779 15.2251 0 14.7905 0H11.2325L11.3219 0.844369C11.3401 1.01645 11.2048 1.16666 11.0316 1.16666H9.96853C9.79536 1.16666 9.6601 1.01645 9.67832 0.844369L9.76765 0H6.2097C5.77476 0 5.37992 0.265779 5.19872 0.680672L0.102249 12.3473C-0.234989 13.1198 0.303133 13.9999 1.1136 13.9999H8.29L8.66588 10.4387C8.69724 10.1419 8.94734 9.91659 9.24593 9.91659H11.7542C12.0528 9.91659 12.3029 10.1419 12.3343 10.4387L12.7102 13.9999H19.8866C20.6971 13.9999 21.2352 13.1198 20.8976 12.3473ZM9.49385 2.59436C9.50142 2.52268 9.53526 2.45634 9.58885 2.40813C9.64244 2.35993 9.71198 2.33328 9.78405 2.33332H11.2165C11.3656 2.33332 11.491 2.44597 11.5067 2.59436L11.6744 4.1832C11.7017 4.44169 11.499 4.66663 11.2395 4.66663H9.76145C9.5015 4.66663 9.29916 4.44169 9.3265 4.1832L9.49385 2.59436ZM11.5078 8.74994H9.49202C9.14567 8.74994 8.87552 8.44989 8.91198 8.10536L9.09682 6.35537C9.12817 6.0586 9.37828 5.83329 9.67687 5.83329H11.3229C11.6215 5.83329 11.8716 6.0586 11.903 6.35537L12.0878 8.10536C12.1243 8.44989 11.8541 8.74994 11.5078 8.74994Z" fill="#021E4F"/>
    </svg>
);

export default RotationRoadIcon;

